export const APP_VERSION = "2.9.6";
